import apiClient from './api';

export type StaffTrainingQuestionType = 'single' | 'multiple' | 'short_answer' | 'judge';

export interface StaffTrainingOption {
  label: string;
  value: string;
}

export interface StaffTrainingQuestion {
  id: string;
  type: StaffTrainingQuestionType;
  title: string;
  options?: StaffTrainingOption[];
  answer: string[];
  matchRate?: number;
  sort: number;
}

export interface StaffTrainingCourse {
  id: string;
  title: string;
  description: string;
  videoUrl: string;
  videoName: string;
  requireWatchComplete: boolean;
  requirePassBeforeAccept: boolean;
  questions: StaffTrainingQuestion[];
  sort: number;
  status: number;
  createdAt: string;
  updatedAt: string;
}

export interface StaffTrainingListParams {
  page?: number;
  pageSize?: number;
  keyword?: string;
  status?: number | 'all';
}

export interface StaffTrainingListResponse {
  list: StaffTrainingCourse[];
  total: number;
  page: number;
  pageSize: number;
}

export type SaveStaffTrainingRequest = Omit<StaffTrainingCourse, 'id' | 'createdAt' | 'updatedAt'>;

export const listStaffTrainings = async (params: StaffTrainingListParams): Promise<StaffTrainingListResponse> => {
  const response = await apiClient.get<StaffTrainingListResponse>('/staff-trainings', { params });
  return response.data;
};

export const createStaffTraining = async (data: SaveStaffTrainingRequest): Promise<StaffTrainingCourse> => {
  const response = await apiClient.post<StaffTrainingCourse>('/staff-trainings', data);
  return response.data;
};

export const updateStaffTraining = async (id: string, data: SaveStaffTrainingRequest): Promise<StaffTrainingCourse> => {
  const response = await apiClient.put<StaffTrainingCourse>(`/staff-trainings/${id}`, data);
  return response.data;
};

export const deleteStaffTraining = async (id: string): Promise<void> => {
  await apiClient.delete(`/staff-trainings/${id}`);
};
